export class MathRoundHelper {
static roundToFixedNumber(number: number, digitsAfter: number): number {
    return Math.round(number * Math.pow(10, digitsAfter)) / Math.pow(10, digitsAfter);
}
}